import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RedeemVoucherResponse } from 'src/app/interfaces/ott-voucher/RedeemVoucherResponse';
import { OttVoucherService } from 'src/app/services/ott-voucher/ott-voucher.service';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-voucher-processing-version-two',
  templateUrl: './voucher-processing.component.html',
  styleUrls: ['./voucher-processing.component.scss']
})
export class VoucherProcessingComponent implements OnInit {
  public loading = false;
  public paymentOptionsLoadedJustify = 'space-between !important';
  public color: ThemePalette = 'primary';
  public diameter = 50;
  public walletClass = '';
  paymentMethod = 'ott_voucher';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ottVoucherService: OttVoucherService,
    private sessionService: SessionService
  ) { }

  ngOnInit(): void {
    this.walletClass = 'wallet-method-container';
    this.loading = true;

    this.ottVoucherService.redeemVoucher(sessionStorage.getItem('voucherNumber'), sessionStorage.getItem('mobileNumber')).subscribe((data: RedeemVoucherResponse) => {
      if (data.success) {
        // handle success
        sessionStorage.setItem('voucher-transaction-successful', 'true');
        sessionStorage.setItem('voucherBalance', data.voucherBalance.toString());
        sessionStorage.setItem('voucherAmount', data.voucherAmount.toString());
      } else {
        // handle failure
        sessionStorage.setItem('voucher-transaction-successful', 'false');
        sessionStorage.setItem('voucher-failure-message', data.message);
      }
      this.router.navigate([`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`]);
    });
  }

}
